module.exports = __webpack_public_path__ + "img/searchNo.4410e25.png";